/* Switch collection presentation in place; cart and product nodes stay intact. */
(() => {
  'use strict';
  if (window.NiralaCollectionView) { window.NiralaCollectionView.init(); return; }
  const media = window.matchMedia('(max-width: 800px)');
  const valid = value => value === 'grid' || value === 'list';
  const mobile = () => media.matches;
  const key = section => 'nirala-collection-view-v1:' + section.dataset.collectionViewKey + ':' + section.dataset.collectionViewSection + ':' + (mobile() ? 'mobile' : 'desktop');
  function saved(section) {
    if (section.dataset.viewControls === 'false' || window.Shopify?.designMode) return null;
    try { const value = sessionStorage.getItem(key(section)); return valid(value) ? value : null; } catch (_) { return null; }
  }
  function apply(section, value) {
    section.dataset.collectionView = valid(value) ? value : 'grid';
    section.querySelectorAll('[data-collection-view-choice]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.collectionViewChoice === section.dataset.collectionView)));
    const controls = section.querySelector('[data-collection-view-controls]');
    if (controls) controls.hidden = false;
  }
  function init() {
    document.querySelectorAll('[data-collection-view-section]').forEach(section => apply(section, saved(section) || (mobile() ? section.dataset.viewMobile : section.dataset.viewDesktop)));
  }
  document.addEventListener('click', event => {
    const button = event.target.closest?.('[data-collection-view-choice]');
    const section = button?.closest('[data-collection-view-section]');
    if (!section || section.dataset.viewControls === 'false' || !valid(button.dataset.collectionViewChoice)) return;
    event.preventDefault();
    apply(section, button.dataset.collectionViewChoice);
    if (!window.Shopify?.designMode) try { sessionStorage.setItem(key(section), button.dataset.collectionViewChoice); } catch (_) { /* The current-page choice still works when browser storage is blocked. */ }
  });
  document.addEventListener('shopify:section:load', init);
  if (typeof media.addEventListener === 'function') media.addEventListener('change', init);
  else if (typeof media.addListener === 'function') media.addListener(init);
  window.NiralaCollectionView = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
